import { useState } from "react";
import { Box, IconButton, Slider, Tooltip } from "@mui/material";
import { GraphicEq } from "@mui/icons-material";

export const EditorDAWGainSlider = ({ onChange, value }) => {
  const [volValue, setValue] = useState(value);

  const handleChange = (v) => {
    if (v && v.target) {
      const newValue = v.target.value;
      onChange(newValue);
      setValue(newValue);
    }
  };

  const increaseGain = () => {
    let newValue = volValue + 10 <= 40 ? volValue + 10 : 40;
    onChange(newValue);
    setValue(newValue);
  };

  const decreaseGain = () => {
    let newValue = volValue - 10 >= -40 ? volValue - 10 : -40;
    onChange(newValue);
    setValue(newValue);
  };

  return (
    <Box display="flex" alignItems="center" flex={0.75} gap={1} width={1}>
      <Tooltip title="Decrease Gain">
        <IconButton onClick={decreaseGain}>
          <GraphicEq color="primary" fontSize="small" />
        </IconButton>
      </Tooltip>
      <Slider
        aria-label="Gain"
        defaultValue={0}
        max={40}
        min={-40}
        size="small"
        step={1}
        value={volValue}
        onChange={handleChange}
      />
      <Tooltip title="Increase Gain">
        <IconButton onClick={increaseGain}>
          <GraphicEq color="primary" fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
